import { render } from "./Invoice.vue?vue&type=template&id=d2219ac4&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"

import "./Invoice.vue?vue&type=style&index=0&id=d2219ac4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2219ac4"]])

export default __exports__